import { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';

const useInactivityLogout = (navigate) => {
  const { instance } = useMsal();

  useEffect(() => {
    let timeout;

    const resetTimeout = () => {
      if (timeout) clearTimeout(timeout);
      timeout = setTimeout(() => {
        instance.logoutPopup().then(() => {
          navigate('/');
        }).catch(e => {
          console.error(e);
        });
      }, 30 * 60 * 1000); // 30 minutes timeout
    };

    const events = ['load', 'mousemove', 'mousedown', 'click', 'scroll', 'keypress'];

    events.forEach(event => window.addEventListener(event, resetTimeout));

    resetTimeout();

    return () => {
      if (timeout) clearTimeout(timeout);
      events.forEach(event => window.removeEventListener(event, resetTimeout));
    };
  }, [instance, navigate]);
};

export default useInactivityLogout;
